/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AgentsHomeExtraProps = {
	cloudId: string;
	projectKey: string;
};

type AgentsHomeEntryPointComponent = EntryPointComponent<{}, {}, {}, AgentsHomeExtraProps>;

export const agentsHomeEntryPoint: EntryPoint<
	AgentsHomeEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<AgentsHomeEntryPointComponent>(
		/* webpackChunkName: "async-jira-project-settings-agents-home" */ './AgentsHomeApp.tsx',
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => ({
		extraProps: {
			cloudId,
			projectKey: context.match.params.projectKey ?? '',
		},
	}),
});
